
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SocialProofLogos from "@/components/SocialProofLogos";
import SimpleHowItWorks from "@/components/SimpleHowItWorks";
import TestimonialsSection from "@/components/TestimonialsSection";
import ProblemSolution from "@/components/ProblemSolution";
import About from "@/components/About";
import DoorDashSavings from "@/components/DoorDashSavings";
import SocialProof from "@/components/SocialProof";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

import EnhancedFeeCalculator from "@/components/EnhancedFeeCalculator";
import MerchantProcessingFAQ from "@/components/MerchantProcessingFAQ";
import BlogSection from "@/components/blog/BlogSection";
import SEOHead from "@/components/SEOHead";
import GlobalStructuredData from "@/components/GlobalStructuredData";
import CanonicalLink from "@/components/CanonicalLink";
import { AuthProvider } from "@/contexts/AuthContext";
import ChatWidget from "@/components/chat/ChatWidget";
import TrustBadges from "@/components/TrustBadges";

const Index = () => {
  return (
    <AuthProvider>
      <SEOHead 
        title="Trusted Merchant Services & Crypto POS | Fort Lauderdale, FL"
        description="Processing Bros provides secure, low-cost credit card processing and innovative Crypto POS systems for small businesses in South Florida. Get your free quote today."
        keywords="merchant services, credit card processing, crypto POS systems, Fort Lauderdale, South Florida, payment processing"
      />
      <GlobalStructuredData />
      <CanonicalLink />
      <main id="main-content" className="min-h-screen bg-background"
            itemScope 
            itemType="https://schema.org/WebPage">
        <Header />
        <Hero />
        
        {/* Social Proof Logo Bar */}
        <SocialProofLogos />
        
        {/* Simple 3-Step How It Works */}
        <SimpleHowItWorks />
        
        {/* Credit Card Processing Fee Calculator Section */}
        <section id="fee-calculator" className="py-16 bg-muted/20" aria-labelledby="calculator-heading">
          <div className="container mx-auto px-4">
            <header className="text-center mb-12">
              <h2 id="calculator-heading" className="text-3xl font-bold mb-4 text-foreground">Calculate Your Credit Card Processing Savings</h2>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                Use our advanced processing fee calculator to compare competitors, see monthly/annual projections, and estimate your potential savings.
              </p>
            </header>
            <EnhancedFeeCalculator />
          </div>
        </section>

        {/* Customer Testimonials */}
        <TestimonialsSection />

        <ProblemSolution />
        <About />
        <DoorDashSavings />
        <SocialProof />
        <BlogSection />
        <MerchantProcessingFAQ />
        
        {/* Local Fort Lauderdale Section */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6 text-foreground">
              Your Local Fort Lauderdale Payment Processing Experts
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              As a locally-owned business, Processing Bros is committed to serving the South Florida business community with personalized service and competitive rates. We understand the unique needs of businesses in Fort Lauderdale, Broward County, Miami-Dade, and Palm Beach County. Our team provides hands-on support to help your business thrive in today's competitive marketplace.
            </p>
          </div>
        </section>

        {/* Trust Badges Section */}
        <TrustBadges />

        <FinalCTA />
        <Footer />
        
        {/* AI Chat Widget */}
        <ChatWidget />
      </main>
    </AuthProvider>
  );
};

export default Index;
